import React from "react";

const WppButton = () => {
    return (
        <div>
            <a
                href="https://wa.me/+558899099358"
                class="whatsapp_float"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i class="fa fa-whatsapp whatsapp-icon"></i>
            </a>
        </div>
    )
}
export default WppButton;